module.exports = __webpack_public_path__ + "img/quienes2.ff924e8f.jpg";